// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css'
Vue.prototype.$bus = new Vue({
  data: {
    arr: []  //用来保存事件名
  },
  methods: {
    //绑定事件
    on(eventname, callback) {
      //判断事件名是否重复
      if (this.arr.includes(eventname)) {
        throw "eventname events already regist!!"
      } else {
        this.arr.push(eventname)
        this.$on(eventname, callback)
      }
    },
    //触发事件，传递数据
    emit(eventname, ...arg) {
      this.$emit(eventname, ...arg)
    },
    // 解绑
		off(eventname, callback) {
      this.$off(eventname, callback)
    }
  }
})
// this.$bus.emit('定义名称', 值) //触发事件 
// this.$bus.on('定义名称' val => { }) //绑定事件 
// this.$bus.off('定义名称') //解绑
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js